module.exports = __webpack_public_path__ + "img/scifi_thumb.5601a91b.jpg";